import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Autocomplete from "@material-ui/lab/Autocomplete";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";

import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const selectTypeProps = {
	options: ['All Records', 'Specific Records'],
	// getOptionLabel: (option) => option.description + ' - ' + option.branchidno
	getOptionLabel:  (option) => option
};


const VoidReport = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();

	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));// jc_user_id_no - branchidno
	const [filterType, setfilterType] = useState(0);//filter type dropdown, 0 - all records, 1 - specific record
	const [fType, setfType] = useState('');//ftype, eg. SO
	const [refNum, setrefNum] = useState('');//ref num

	// Data Fetching
	useEffect(() => {
		data();
	}, []);
	const x = 0;

	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	//search button
	const dataFilter = async () => {
		setDataLoaded(false);
        const result = await axios.get(
			process.env.REACT_APP_API_URL+'get_void_report', {
            params:{
                date_from: format(dateRange.startDate, "yyyy/MM/dd/"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy/MM/dd/"),   //format(dateRange.endDate, "yyyy/MM/dd/")
				jc_user_id_no: useridNo,  
				filter_type: filterType,
				ftype : fType,
				ref_no : refNum,
            }
        })
		setPosts(result.data.data);
		setDataLoaded(true);
    }

	const data = async () => {
		// const res = await axios.get(
		// process.env.REACT_APP_API_URL+'get_void_report',  {
        //     params:{
        //         date_from: '2015/01/01/', 
        //         date_to: '2016/12/01/',   
		// 		jc_user_id_no: '00593494', 
		// 		filter_type: 0,
		// 		ftype : 'SO',
		// 		ref_no : 12, 
        //     }
        // })		
		// console.log(res.data);
		// console.log(res.data.data);
	    // setPosts(res.data.data);

		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		{
			name: "id",
			label: "id",
		},
		{
			name: "trandate",
			label: "Tran Date",
		},
		{
			name: "ftype",
			label: "ftype",
		},
		{
			name: "refid",
			label: "Reference ID"
		},
		{
			name: "username",
			label: "Username"
		},
		{
			name: "status",
			label: "Status"
		},
		{
			name: "branchidno",
			label: "Branch ID No"
		},
		{
			name: "reason",
			label: "Reason"

		},
		{
			name: "typemask",
			label: "Type Mask"

		},
	];

	const options = {
		filter: true,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		download: downloadFlag,  //add this
		print: downloadFlag, //add this
		downloadOptions: {
			filename : 'VoidReport.csv' //change filename of csv
		}
		
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<NavLink to={"/reports"}><h4 style={{color:"#339933"}}>Reports</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Void Report</h4>
			</div>
			<div className="page-container">
				<div style={style}>
					<Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>

						<Grid item xs={12} sm={5} lg={5} xl={3}>
							 {/* <NativeSelect
								value={filterType}
								onChange={e => setfilterType(e.target.value)}
								inputProps={{
									name: 'Filter Type',
								}}>
								<option value=''>Choose Type</option>
								<option value='0'>All Records</option> 
								<option value='1'>Specific Records</option> 	  
							</NativeSelect>
							<FormHelperText>Select Type</FormHelperText>  */}
							<Autocomplete
									    style={{marginTop:  "-15px"}}
                                        {...selectTypeProps}
                                        autoComplete
                                        includeInputInList
										className={classes.autoComplete}
                                        renderInput={(params) => (
                                            <TextField
												{...params}
                                                margin="normal"
                                                label="Select Type"
												variant="outlined"
												required="true"
                                            />
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												//prep_data.warehouse = JSON.stringify(newValue.id, null, ' ');
												//console.log(JSON.stringify(newValue.id, null, ' '));
												console.log(newValue);
												if(newValue === 'All Records')
													setfilterType(0);
												else if(newValue === 'Specific Record'){
													setfilterType(1);
												}
											}
										}}
                            />
						</Grid>

						{/* <Grid item xs={2}>
							<Input style={{marginTop:  "21px"}} placeholder="Branch ID No" inputProps={{ 'aria-label': 'branch id no' }} onChange={e => setuseridNo(e.target.value)}/>
						</Grid> */}

						<Grid item xs={12} sm={4} lg={4} xl={2}> 
							<Input style={{marginTop:  "21px"}} fullWidth={true} placeholder="Reference No" inputProps={{ 'aria-label': 'reference no' }} onChange={e => setrefNum(e.target.value)}/>
						</Grid>

						<Grid item xs={12} sm={4} lg={4} xl={2}> 
							<Input style={{marginTop:  "21px"}} fullWidth={true} placeholder="F Type" inputProps={{ 'aria-label': 'f type' }} onChange={e => setfType(e.target.value)}/>
						</Grid>

						<Grid item xs={12} sm={4} lg={4} xl={3} style={{ display: "flex", justifyContent: "flex-end" }}> 
							<Button style={{marginTop:  "21px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
						</Grid>
					</Grid>
				</div>

				{!dataLoaded ? (
					<Preloader />
				) : (
					<MUIDataTable
						title={
							<div>
						
								<div className="table-title">
								 Void Report
								</div>
							</div>
						}
						data={posts}
						columns={columns}
						options={options}
					/>
				)}
			</div>
		</div>
	);
};

export default VoidReport;
